const lozad = require('lozad');
const contentUrl = require('../../lib/static-content-url');
const {createResponsiveBlockImages} = require('./responsive-block-images');

const getPlaceholderImage = (el) => {
    if (el && el.dataset && el.dataset.placeholderImage) {
        return el.dataset.placeholderImage;
    }
    return contentUrl.cdnUrl(contentUrl.vehiclePlaceholderKey);
};

const applyImageFallback = (imgEl, placeholder) => {
    if (!imgEl || !placeholder) return;

    if (imgEl.getAttribute('src') !== placeholder) {
        imgEl.setAttribute('src', placeholder);
    }

    if (imgEl.dataset) {
        imgEl.dataset.src = placeholder;
    }

    const picture = imgEl.parentElement;
    if (picture && picture.nodeName === 'PICTURE') {
        const sources = picture.querySelectorAll('source');
        const fallbackSrcset = placeholder.indexOf(' ') === -1 ? placeholder + ' 1x' : placeholder;
        sources.forEach(function (source) {
            if (source.hasAttribute('data-srcset')) {
                source.setAttribute('data-srcset', fallbackSrcset);
            }
            if (source.getAttribute('srcset') !== fallbackSrcset) {
                source.setAttribute('srcset', fallbackSrcset);
            }
        });
    }
};

const observer = lozad('.lozad:not([data-responsive-image])', {
    rootMargin: '250px 0px',
    loaded: function (el) {
        if (el.localName === 'img') {
            let objImg = new Image();

            objImg.onload = function () {
                el.classList.add('lozad--loaded');
                setTimeout(function () {
                })
            };

            objImg.onerror = function () {
                const fallback = getPlaceholderImage(el);
                applyImageFallback(el, fallback);
                el.classList.add('lozad--loaded');
            };

            objImg.src = $(el).data('src');
        } else if (el.localName === 'picture') {
            el.classList.add('lozad--loading');
            let watcher = setInterval(function () {
                const imgEl = el.querySelector('img');
                if (!imgEl) {
                    return;
                }

                const currentSrc = imgEl.currentSrc;
                if (currentSrc) {
                    window.clearInterval(watcher);
                    let objImg = new Image();
                    const placeholder = getPlaceholderImage(imgEl);

                    objImg.onload = function () {
                        el.classList.add('lozad--loaded');
                    };

                    objImg.onerror = function () {
                        applyImageFallback(imgEl, placeholder);
                        el.classList.add('lozad--loaded');
                    };

                    objImg.src = currentSrc;
                    imgEl.addEventListener('error', function handleError() {
                        imgEl.removeEventListener('error', handleError);
                        applyImageFallback(imgEl, placeholder);
                        el.classList.add('lozad--loaded');
                    }, {once: true});
                }
            }, 100);
        } else if (el.localName === 'div') {
            let objImg = new Image();

            const backgroundImage = $(el).data('background-image');
            const placeholder = getPlaceholderImage(el);

            if (!backgroundImage) {
                el.style.backgroundImage = `url('${placeholder}')`;
                el.classList.add('lozad--loaded');
                return;
            }

            objImg.onload = function () {
                el.style.backgroundImage = `url('${backgroundImage}')`;
                el.classList.add('lozad--loaded');
            };

            objImg.onerror = function () {
                el.style.backgroundImage = `url('${placeholder}')`;
                el.classList.add('lozad--loaded');
            };

            objImg.src = backgroundImage;
        } else if (el.localName === 'iframe') {
            el.classList.add('lozad--loaded');
            if (el.parentNode.classList.contains('video')) {
                setTimeout(() => {
                    el.parentNode.style.background = 'rgba(0,0,0,0)';
                }, 300)
            }
        } else {
            el.classList.add('lozad--loaded');
        }

    }
});

const responsiveImages = createResponsiveBlockImages({
    lozad,
    getPlaceholderImage,
    applyImageFallback
});

observer.observe();
responsiveImages.observe();

module.exports = {
    observe: () => {
        observer.observe();
        responsiveImages.observe();
    }
};
